import type { CustomSurveySummary } from '@/api/surveys';

type ReadinessBadgeVariant = 'neutral' | 'success';

export interface CustomSurveyReadiness {
    /** A published version exists, so the form can be sent to patients. */
    isReady: boolean;
    /** There are draft edits that are not yet part of the sendable version. */
    hasUnpublishedEdits: boolean;
    badgeLabel: string;
    badgeVariant: ReadinessBadgeVariant;
    /** Short muted hint explaining what the neuropsychologist should do next. */
    hint: string | null;
}

/**
 * Collapses the two-slot draft/published model into the single question a
 * neuropsychologist actually cares about: "is this form ready to send?".
 * The publication nouns ("Rascunho"/"Publicado") are kept, and a plain hint
 * makes sendability (and any unpublished edits) explicit.
 */
export function getCustomSurveyReadiness(survey: CustomSurveySummary): CustomSurveyReadiness {
    const isReady = survey.published != null;
    const hasUnpublishedEdits = isReady && survey.draft != null;

    if (!isReady) {
        return {
            isReady,
            hasUnpublishedEdits: false,
            badgeLabel: 'Rascunho',
            badgeVariant: 'neutral',
            hint: 'Publique para poder enviar.',
        };
    }

    return {
        isReady,
        hasUnpublishedEdits,
        badgeLabel: 'Publicado',
        badgeVariant: 'success',
        hint: hasUnpublishedEdits ? 'Alterações não publicadas — publique para aplicá-las.' : null,
    };
}
